import userService from '../../services/user.service';
import {
  APPLICATION_REFRESH_DATE,
  APP_IS_READY,
  AUTH_LOGIN,
  AUTH_UPDATE_TOKEN,
  INITIAL_STATE,
  LAB_DELETE_CATEGORY,
  LAB_DELETE_ITEM,
  LAB_UPDATE_CATEGORY,
  LAB_UPDATE_CATEGORY_LOCATION,
  LAB_USE_CACHE,
  OWNERS_TRANSFER_OWNERSHIP,
} from '../actions';
import { getLabData } from '../actions/lab.actions';

export const labCacheMiddleware =
  ({ dispatch, getState }) =>
  next =>
  action => {
    next(action);

    if (action.type === INITIAL_STATE) {
      const { lab } = getState();
      const hasCachedData = lab.items?.length > 0;

      if (hasCachedData) {
        dispatch({ type: LAB_USE_CACHE });
      }
    }
  };

export const labFetchDataMiddleware =
  ({ dispatch }) =>
  next =>
  async action => {
    next(action);

    if (
      action.type === AUTH_LOGIN ||
      action.type === APP_IS_READY ||
      action.type === AUTH_UPDATE_TOKEN ||
      action.type === APPLICATION_REFRESH_DATE ||
      action.type === OWNERS_TRANSFER_OWNERSHIP ||
      action.type === LAB_UPDATE_CATEGORY_LOCATION
    ) {
      if (!userService.isAuthenticated) return false;

      dispatch(getLabData());
    }
  };

export const labOnCategoryChangeOwnerIdMiddleware =
  ({ dispatch }) =>
  next =>
  async action => {
    next(action);

    if (action.type === LAB_UPDATE_CATEGORY) {
      if (!action.payload.ownerIds) return false;

      dispatch(getLabData());
    }
  };

export const labOnCategoryAndItemDeleteMiddleware =
  ({ dispatch }) =>
  next =>
  async action => {
    next(action);

    if (action.type === LAB_DELETE_CATEGORY || action.type === LAB_DELETE_ITEM) {
      dispatch(getLabData());
    }
  };

export const labMiddleware = [
  labCacheMiddleware,
  labFetchDataMiddleware,
  labOnCategoryChangeOwnerIdMiddleware,
  labOnCategoryAndItemDeleteMiddleware,
];
